import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button } from '@material-ui/core';
import { InfoCard } from '@backstage/core-components';
import { BlogPostCard, BlogPost } from './BlogPostCard';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles(theme => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  viewAllButton: {
    textTransform: 'none',
  },
}));

// Sample blog posts - these would be dynamically loaded from TechDocs in a future enhancement
const blogPosts: BlogPost[] = [
  {
    title: 'Welcome to AI Central',
    date: 'January 29, 2026',
    excerpt:
      'Introducing AI Central - your new hub for all things AI at AvidXchange. Learn about the resources, tools, and best practices available to help you integrate AI into your development workflow.',
    href: '/docs/default/component/avid-developer-portal/ai-central/blog/2026-01-welcome/',
    tags: ['Announcement', 'Getting Started'],
  },
  {
    title: 'Getting Started with MCP Servers',
    date: 'January 28, 2026',
    excerpt:
      'Model Context Protocol (MCP) servers enable AI assistants to interact with external tools and data sources. Learn how to set up and use MCP servers in your development environment.',
    href: '/docs/default/component/avid-developer-portal/ai-central/resources/mcp-guide/',
    tags: ['MCP', 'Tools'],
  },
  {
    title: 'Prompt Engineering Best Practices',
    date: 'January 27, 2026',
    excerpt:
      'Master the art of writing effective prompts for AI models. This guide covers techniques for getting better results from AI assistants and code generation tools.',
    href: '/docs/default/component/avid-developer-portal/ai-central/resources/prompt-engineering/',
    tags: ['Best Practices', 'Prompts'],
  },
];

export const BlogPostsGrid = () => {
  const classes = useStyles();

  return (
    <InfoCard
      title="Latest Posts"
      action={
        <Button
          size="small"
          endIcon={<ArrowForwardIcon />}
          className={classes.viewAllButton}
          href="/docs/default/component/avid-developer-portal/ai-central/blog/"
        >
          View All
        </Button>
      }
    >
      <Grid container spacing={2}>
        {blogPosts.map(post => (
          <Grid item xs={12} sm={6} md={4} key={post.title}>
            <BlogPostCard post={post} />
          </Grid>
        ))}
      </Grid>
    </InfoCard>
  );
};
